module.exports = __webpack_public_path__ + "fonts/6967274.woff";